import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-2" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "section__title" }, "Simple alerts:", -1)
const _hoisted_3 = { class: "w-full grid--auto-cols gap-4" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Lorem ipsum dolor sit, amet consectetur adipisicing elit. Incidunt accusamus porro maxime, veniam pariatur asperiores? ")
const _hoisted_5 = /*#__PURE__*/_createVNode("h1", { class: "section__title" }, "WAlert with titles :", -1)
const _hoisted_6 = { class: "w-full grid--auto-cols gap-4" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Lorem ipsum dolor sit, amet consectetur adipisicing elit. Incidunt accusamus porro maxime, veniam pariatur asperiores? ")
const _hoisted_8 = /*#__PURE__*/_createVNode("h1", { class: "section__title" }, "Outlined alerts :", -1)
const _hoisted_9 = { class: "w-full grid--auto-cols gap-4" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Lorem ipsum dolor sit, amet consectetur adipisicing elit. Incidunt accusamus porro maxime, veniam pariatur asperiores? ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_alert = _resolveComponent("w-alert")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(), _createBlock(_resolveDynamicComponent('img'))),
    _createVNode("div", _hoisted_3, [
      (_ctx.isReset)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.reset(...args))),
            class: "mt-8 px-8 py-2 bg-navy-blue-800 text-navy-blue-100 shadow-md rounded-sm self-end focus:outline-none hover:bg-navy-blue-900 place-self-start"
          }, " RESET "))
        : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.variants, (variant) => {
            return (_openBlock(), _createBlock(_component_w_alert, {
              variant: variant.type,
              modelValue: variant.show,
              "onUpdate:modelValue": $event => (variant.show = $event)
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["variant", "modelValue", "onUpdate:modelValue"]))
          }), 256 /* UNKEYED_FRAGMENT */))
    ]),
    _hoisted_5,
    _createVNode("div", _hoisted_6, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.variants2, (variant) => {
        return (_openBlock(), _createBlock(_component_w_alert, {
          title: "WAlert title",
          variant: variant.type,
          modelValue: variant.show,
          "onUpdate:modelValue": $event => (variant.show = $event)
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 2
        }, 1032, ["variant", "modelValue", "onUpdate:modelValue"]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ]),
    _hoisted_8,
    _createVNode("div", _hoisted_9, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.variants2, (variant) => {
        return (_openBlock(), _createBlock(_component_w_alert, {
          title: "WAlert title",
          outlined: "",
          variant: variant.type,
          modelValue: variant.show,
          "onUpdate:modelValue": $event => (variant.show = $event)
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 2
        }, 1032, ["variant", "modelValue", "onUpdate:modelValue"]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ]))
}